import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AlterarPerfilClienteResponse } from '../shared/models/alterar-perfil-cliente-response.model';
import { AlterarSenhaRequest } from '../shared/models/alterar-senha-request.model';
import PerfilCliente from '../shared/models/perfil-cliente.model';
import { ConfirmarTokenAlteracaoRequest } from '../shared/models/confirmar-token-alteracao-request.model';
import BrowserUtils from '../shared/utils/browser-utils';
import { ApiService } from '../shared/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  async getPerfil(): Promise<PerfilCliente> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/perfil',
      oldBrowserFallbackPath: '/cobrancas/alterar/perfil'
    })

    return this.http.get<PerfilCliente>(path).toPromise();
  }

  async alterarDadosBasicos(dadosBasicos: PerfilCliente) {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/dados-basicos',
      oldBrowserFallbackPath: '/cobrancas/alterar/dados-basicos'
    })

    await this.http.put(path, dadosBasicos).toPromise();
  }

  async alterarSenha(alterarSenhaRequest: AlterarSenhaRequest): Promise<void> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/alterar-senha',
      oldBrowserFallbackPath: '/cobrancas/alterar/alterar-senha'
    })

    await this.http.put(path, alterarSenhaRequest).toPromise();
  }

  async alterarEmail(email: string): Promise<AlterarPerfilClienteResponse> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/alterar-email',
      oldBrowserFallbackPath: '/cobrancas/alterar/alterar-email'
    })

    return this.http.put<AlterarPerfilClienteResponse>(path, email).toPromise();
  }

  async alterarTelefone(telefone: string): Promise<AlterarPerfilClienteResponse> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/alterar-telefone',
      oldBrowserFallbackPath: '/cobrancas/alterar/alterar-telefone'
    })

    return this.http.put<AlterarPerfilClienteResponse>(path, `+55${telefone}`).toPromise();
  }

  async confirmarTokenSenha(confirmarTokenAlteracaoRequest: ConfirmarTokenAlteracaoRequest): Promise<void> {

    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/confirmar-senha',
      oldBrowserFallbackPath: '/cobrancas/alterar/confirmar-senha'
    })
    await this.http.put(path, confirmarTokenAlteracaoRequest).toPromise();
  }

  async confirmarTokenEmail(confirmarTokenAlteracaoRequest: ConfirmarTokenAlteracaoRequest): Promise<void> {

    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/confirmar-email',
      oldBrowserFallbackPath: '/cobrancas/alterar/confirmar-email'
    })
    await this.http.put(path, confirmarTokenAlteracaoRequest).toPromise();
  }

  async confirmarTokenTelefone(confirmarTokenAlteracaoRequest: ConfirmarTokenAlteracaoRequest): Promise<void> {
    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: '/cobranca-orquestrador-registro/cobrancas/alterar/confirmar-telefone',
      oldBrowserFallbackPath: '/cobrancas/alterar/confirmar-telefone'
    })

    await this.http.put(path, confirmarTokenAlteracaoRequest).toPromise();
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return `${environment.cdccorpApiURLService}/v1`;
    }

    return `${environment.apiURLService}/v1`;
  }

}
